import {applyMiddleware, createStore} from 'redux';
import {persistStore, persistReducer} from 'redux-persist';
import {composeWithDevToolsDevelopmentOnly} from '@redux-devtools/extension';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import createRootReducer from './reducers';
import googleAnalyticsMiddleware from './middleware/googleanalytics';

const middlewares = [googleAnalyticsMiddleware];
const enhancers = [applyMiddleware(...middlewares)];

const persistConfig = {
  key: 'root',
  storage,
  blacklist: [] // Removed 'router' as it's no longer part of the state
};

const persistedReducer = persistReducer(persistConfig, createRootReducer());

const configureStore = preloadedState => {
  const store = createStore(persistedReducer,
    preloadedState,
    composeWithDevToolsDevelopmentOnly(...enhancers));

  const persistor = persistStore(store);

  // persistor.purge();

  return {store, persistor};
};

export default configureStore;
